import { render } from "./splunkHec.vue?vue&type=template&id=90364176"
import script from "./splunkHec.vue?vue&type=script&lang=js"
export * from "./splunkHec.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__